import Container from "react-bootstrap/Container";
import FormSection from "../../components/formsection";
import Button from "react-bootstrap/Button";
import { Row, Col, Card } from "react-bootstrap";
import Faq from "../../components/Faq";
import "../../styles/dualEducation.css";
import SliderCalculator from "../../components/SliderCalculator";
import ResultsSection from "../../components/ResultSection";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

export default function DualEducation() {
  const usps = [
    "Díjmentes tanácsadás",
    "Előminősítés 24 órán belül",
    "Sikerdíj alapú együttműködés",
    "Fluktuáció csökkentése",
    "Jövedelemtámogatás",
    "Járulékfizetési támogatás",
  ];

  return (
    <>
      {/* ── Hero + Lead Form: first view ── */}
      <Container className="hero hero-compact mx-md-auto px-1">
        <span className="badge">
          ÚJ: egyszerűsített igénylés, teljes ügyintézés
        </span>

        <h1 className="title">
          Fejleszd csapatod{" "}
          <span style={{ color: "#c7d2fe" }}>állami támogatással</span>
        </h1>

        <p className="subtitle mb-2">
          Testreszabott, <strong>online</strong> képzések, amelyek a
          vállalkozásod céljaihoz igazodnak – kiesés nélkül, maximális hatással.
          Oktatás mellé céged állami támogatást is igényelhet.
        </p>
      </Container>

      <Container id="leadform" className="px-1">
        <Row className="align-items-start g-4">
          <Col md={4} className="order-1">
            <div className="form-highlight">
              <FormSection formType="Duális képzés" />
            </div>
          </Col>

          <Col md={6} className="order-2 ms-md-5 ps-md-5 pt-2">
            <h2
              className="h5 fw-bold mb-4"
              style={{ color: "var(--title-color)" }}
            >
              Kérd szakértőnk díjmentes segítségét!
            </h2>
            <ul className="list-unstyled">
              {usps.map((item, i) => (
                <li key={i} className="mb-3 d-flex align-items-center gap-3">
                  <div
                    className="d-flex align-items-center justify-content-center flex-shrink-0"
                    style={{
                      width: "36px",
                      height: "36px",
                      background: "rgba(251, 191, 36, 0.08)",
                      borderRadius: "10px",
                      border: "1px solid rgba(252, 211, 77, 0.2)",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faCheck}
                      style={{ fontSize: "14px", color: "#fcd34d" }}
                    />
                  </div>
                  <span
                    className="fw-semibold"
                    style={{ color: "var(--title-color)", fontSize: "15px" }}
                  >
                    {item}
                  </span>
                </li>
              ))}
            </ul>
            <div className="mt-4">
              <Button href="#calculation" className="btn btn-secondary btn-sm">
                Számold ki a támogatást ↓
              </Button>
            </div>
          </Col>
        </Row>
      </Container>

      <Container>
        <section className="section">
          <Row className="g-3">
            <Col md={4}>
              <Card className="card">
                <div className="kpi">Egyszerű</div>
                <div className="muted">
                  Az adminisztráció 95%-át átvesszük a cég válláról
                </div>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="card">
                <div className="kpi">Online</div>
                <div className="muted">
                  Rugalmas, online képzés, ami teljesen a cégre szabható
                </div>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="card">
                <div className="kpi">Eredményalapú</div>
                <div className="muted">
                  Első a céged támogatása, mi csak siker esetén vagyunk
                  jogosultak bevételre
                </div>
              </Card>
            </Col>
          </Row>
        </section>

        <section id="miert" className="section">
          <h2 className="h2">Milyen előnyőket biztosít céged számára?</h2>
          <p className="lead">
            Az új felnőttképzési rendszer lehetővé teszi, hogy a cégek{" "}
            <strong>saját igényeik szerint</strong> fejlesszék a munkavállalókat
            úgy, hogy mindeközben – <strong>állami támogatásra</strong> is
            jogosultak.
          </p>
          <p>Milyen hozadékai lehetnek egy ilyen képzésnek?</p>

          <Row className="g-3">
            <Col md={6}>
              <Card className="card">
                <h3>Előny a cégednek</h3>
                <ul className="list check-list">
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    Járulékfizetési támogatás az oktatás időtartama alatt
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    Jövedelemtámogatás a munkavállalóknak
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    Online, rugalmas képzés, akár munkaidőben, akár azon kívül
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    Tananyag-illesztés, céges igények szerint alakítható képzés
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    Fluktuáció csökkentése, képzett munkaerő megtartása
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    Viszgabónusz a cégnek sikeres vizsgák esetén
                  </li>
                </ul>
              </Card>
            </Col>

            <Col md={6}>
              <Card className="card">
                <h3>Előny a munkavállalóidnak</h3>
                <ul className="list check-list">
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    Online, rugalmas tanulás, munkaidőben vagy azon kívül
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    Magasabb, támogatott jövedelem a képzés ideje alatt
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    Szükséges készségek fejlesztése, hatékonyabb munkavégzés
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    Akár nyelvvizsga-felkészítés
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    Akkreditált bizonyítvány sikeres vizsga esetén
                  </li>
                </ul>
              </Card>
            </Col>
          </Row>
        </section>

        <Container id="calculation">
          <SliderCalculator />
        </Container>

        <section id="ellenorzo" className="section">
          <h2 className="h2">Kik számára elérhető?</h2>
          <p className="lead">
            A támogatott képzás alapvetően minden cég számára elérhető, azonban
            az igényléshez néhány alapvető feltételnek meg kell felelni:
          </p>
          <Row className="g-3">
            <Col md={6}>
              <Card className="card">
                <h3>Jogosultsági feltételek</h3>
                <ul className="list check-list">
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    Bejelentett munkavállalók a képzés ideje alatt
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    Magyarországi székhely/telephely
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    Munkavégzéshez szükséges eszközök biztosítása
                  </li>
                </ul>
              </Card>
            </Col>

            <Col md={6}>
              <Card className="card">
                <h3>Kizáró okok</h3>
                <ul className="list check-list">
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    Fiktív képzési cél
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    Be nem jelentett munkavállalók
                  </li>
                </ul>
              </Card>
            </Col>
          </Row>
        </section>

        <Container>
          <h2 className="h2">Eredményeink számokban</h2>
          <ResultsSection />
        </Container>

        <section id="faq" className="section pb-0">
          <h2 className="h2">Gyakran ismételt kérdések</h2>

          <Faq
            categories={[
              {
                key: "altalanos",
                label: "Általános",
                items: [
                  {
                    question: "Meddig tart egy képzés?",
                    answer:
                      "Jellemzően 10–12 hónap, tematikától, és szakmától függően. Az elmúlt évek tapasztalatai szerint a képzések átlagosan 12 hónapig tartank.",
                  },
                  {
                    question: "Hogy kapja meg egy cég a támogatást?",
                    answer:
                      "A támogatás az adófolyószámlára érkezik különböző adónemekben. Épp ezért a programban való részvételhez szükséges aktív együttműködés a bérszámfejtővel.",
                  },
                  {
                    question: "Mikor, hol történik a képzés?",
                    answer:
                      "A képzések többségében online történnek, de van lehetőség személyes oktatásra is. A képzések nincsenek időhöz kötve, hallgatóink között vannak akik hétvégente szánják rá a szükséges 1-1,5 órát, van olyan munkáltató aki beépítette a munkaidőbe mint közösen felhasznált idő. A képzések az év bármelyik hónapjában indulhatnak, nem naptári évhez között és hogy akár az első megbeszéléstől számított 3 hét után kezdhetnek.",
                  },
                ],
              },
            ]}
          />
        </section>
      </Container>
    </>
  );
}
